import React from "react";

const PHRASES = [
  "GROUNDED",
  "RESILIENT",
  "INTENTIONAL",
  "TRANSFORMED",
  "RETURN TO SELF",
  "STOP PERFORMING",
  "TELL THE TRUTH",
];

const Marquee = () => {
  // Duplicate for seamless loop
  const items = [...PHRASES, ...PHRASES, ...PHRASES, ...PHRASES];
  return (
    <div className="marquee" data-testid="marquee-bar">
      <div className="marquee-track">
        {items.map((p, i) => (
          <React.Fragment key={i}>
            <span>{p}</span>
            <span className="sep">❖</span>
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
